import overview from '../assets/release-2026-10-27/dashboard-01-uebersicht.png'
import { makeBox, type GuideStepContent } from './guideStep'

/** Window screenshot, 2033×1162; measured on its 2000×1143 preview, which gives the same percentages. */
const box = makeBox(2000, 1143)

export const DASHBOARD_INTRO =
  'Nach der Anmeldung öffnet sich für die Leitung das Dashboard. Es zeigt den Stand der Aufträge auf einen Blick.'

export const DASHBOARD_STEPS: GuideStepContent[] = [
  {
    title: 'Was das Dashboard zeigt',
    text: 'Oben wählen Sie den Zeitraum, monatsweise ab 09/2026. Darunter stehen die Kennzahlen, die Aufträge nach Gewerk und nach Status sowie Soll und Ist pro Monat — als Anzahl, in Euro oder in Stunden. Ein Klick auf ein Gewerk oder einen Status filtert die anderen Ansichten.',
    note: { title: 'Noch nicht enthalten', text: 'Ein Export folgt später.' },
    image: overview,
    imageAlt: 'Dashboard mit Zeitraum, Kennzahlen, Aufträgen nach Gewerk und nach Status',
    focus: [
      box(390, 305, 1210, 380),
      box(380, 428, 1902, 566),
      box(380, 600, 1165, 1068),
      box(1188, 600, 1902, 890),
    ],
    wide: true,
  },
]
